import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Styles from './index.styles';

const { StyledNotification, StyledIcon } = Styles;

export const Notification = ({
    visible: visibleProp,
    fixed,
    onClose,
    timeout,
    icon,
    children,
    ...otherProps
}) => {
    const [visible, setVisible] = useState(visibleProp);

    useEffect(() => {
        setVisible(visibleProp);

        if (visibleProp && timeout) {
            setTimeout(() => {
                setVisible(false);
                onClose();
            }, timeout);
        }
    }, [visibleProp, timeout]);

    const handleOnClose = evt => {
        setVisible(false);
        onClose(evt);
    };

    return (
        <StyledNotification visible={visible} fixed={fixed} {...otherProps}>
            {children}
            {icon ? <StyledIcon icon={['fal', 'xmark']} onClick={handleOnClose} /> : null}
        </StyledNotification>
    );
};

Notification.propTypes = {
    visible: PropTypes.bool,
    fixed: PropTypes.bool,
    onClose: PropTypes.func,
    timeout: PropTypes.number,
    icon: PropTypes.bool,
    type: PropTypes.oneOf(['info', 'success', 'error', 'warn']),
    children: PropTypes.node,
};

Notification.defaultProps = {
    visible: false,
    fixed: false,
    onClose: () => null,
    icon: true,
    type: 'success',
    timeout: 0,
    children: null,
};

Notification.Styles = Styles;
